export default {
  pluralization: {},
  pending: {
    operation: 'Операция выполняется, пожалуйста, подождите ...',
    hardware: 'Проверка оборудования, пожалуйста, подождите ...',
    fetch: 'Загружаем данные, пожалуйста, подождите ...',
    pay: 'Идет обработка платежа, пожалуйста, подождите...',
    print: 'Печатаю, пожалуйста, подождите...',
    processing: 'Идет обработка, пожалуйста, подождите...',
    recognize: 'Пожалуйста, снимите маску, чтобы я мог разглядеть ваше лицо',
    edit: 'Изменение персональных данных...',
    scan: 'Идет сканирование, подождите...',
    meter: 'Передача показаний...',
    account: 'Добавление лицевого счета...',
    sign: 'Выполняется вход в личный кабинет...',
  },
  fields: {
    fileLabel: 'Файл',
    nameLabel: 'Имя',
    namePlaceholder: 'Введите имя',
    nameError: 'Введите свое имя',
    fullnameLabel: 'ФИО',
    fullnamePlaceholder: 'Введите фамилию, имя и отчество',
    fullnameError: 'Введите полное имя',
    emailLabel: 'Email',
    emailPlaceholder: 'Введите электронную почту',
    emailError: 'Email введен неверно',
    emailInvalidError: 'Пользователь с таким E-mail уже зарегистрирован',
    emailRequirement: 'Укажите адрес Вашей электронной почты по примеру mymail@yandex.ru',
    phoneLabel: 'Номер телефона',
    phonePlaceholder: 'Введите номер телефона',
    phoneError: 'Введите номер телефона правильно, например: +7(911)919-5995',
    phoneRequirement: 'Введите Ваш номер телефона начиная с +7',
    passwordLabel: 'Пароль',
    passwordPlaceholder: 'Введите пароль',
    passwordError: 'Длина пароля должна быть не менее {min} и не более {max} символов',
    loginLabel: 'Логин',
    loginPlaceholder: 'Введите логин',
    loginError: 'Введите логин в соответствии с требованиями к логину',
    loginInvalidError: 'Пользователь с таким логином уже зарегистрирован',
    loginLengthRequirement: 'Длина логина не менее 6 символов;',
    loginLetterRequirement: 'Поле поддерживает ввод только букв латинского алфавита (A-z), кириллицу (А-я), цифры (0-9) и символы ".", "_", "-"',
    sumLabel: 'Сумма к оплате, ₽',
    sumPlaceholder: 'Введите сумму',
    sumError: 'Сумма не может быть меньше {min}',
    reduplicationLabel: 'Подтверждение пароля',
    reduplicationPlaceholder: 'Введите пароль еще раз',
    reduplicationError: 'Должно совпадать с данными, введенными в поле «Пароль»',
    accountСodeLabel: 'Номер лицевого счета',
    accountСodePlaceholder: 'Введите номер счета',
    accountСodeError: 'Номер лицевого счета должен содержать {length} цифр',
    meterLabel: 'Укажите текущее показание',
    meterPlaceholder: 'Введите показание',
    meterError: 'Не может быть меньше предыдущего',
    meterPrevLabel: 'Предыдущее показание',
    meterDateLabel: 'Дата передачи предыдущих показаний',
    meterNumber: 'Счетчик: {number}',
    organizationLabel: 'Отделение',
    organizationPlaceholder: 'Выберите отделение',
    organizationSearchPlaceholder: 'Введите название отделения',
    organizationEmptyPlaceholder: 'Список организаций пуст',
    organizationError: 'Выберите отделение из списка',
    cityLabel: 'Населенный пункт',
    cityPlaceholder: 'Выберите населенный пункт',
    citySearchPlaceholder: 'Введите название населенного пункта',
    cityEmptyPlaceholder: 'В базе данных нет населенных пунктов для выбранного отделения',
    cityError: 'Выберите населенный пункт из списка',
    streetLabel: 'Улица',
    streetPlaceholder: 'Выберите улицу',
    streetSearchPlaceholder: 'Введите название улицы',
    streetEmptyPlaceholder: 'В базе данных нет улиц для «{city}»',
    streetError: 'Выберите улицу из списка',
    houseLabel: 'Дом',
    housePlaceholder: 'Выберите дом',
    houseSearchPlaceholder: 'Введите номер дома',
    houseEmptyPlaceholder: 'В базе данных нет домов для «{street}»',
    houseError: 'Выберите дом из списка',
    premiseLabel: 'Квартира',
    premisePlaceholder: 'Выберите квартиру',
    premiseSearchPlaceholder: 'Введите номер квартиры',
    premiseEmptyPlaceholder: 'В базе данных нет квартир для дома «{house}»',
    premiseError: 'Выберите квартиру из списка',
    accountLabel: 'Лицевой счет',
    accountPlaceholder: 'Выберите лицевой счет',
    accountError: 'Выберите лицевой счет из списка',
    searchPlaceholder: 'Поиск по названию',
    emptyPlaceholder: 'Список пуст',
  },
  titles: {
    admin: 'Сервисное меню',
    service: 'Услуга',
    thanks: 'Спасибо!',
    badConnection: 'Ошибка соединения',
    badHardware: 'Ошибка оборудования',
    email: 'Введите E-mail',
    success: 'Готово!',
    feedback: 'В каком формате оставить отзыв?',
    audioFeedback: 'Аудио отзыв',
    videoFeedback: 'Видео отзыв',
    signin: 'Для входа введите данные',
    signup: 'Введите регистрационные данные',
    personal: 'Личный кабинет',
    meters: 'Приборы учета',
    confirmAbortRecording: 'Вы уверены, что хотите прервать запись отзыва?',
    recordIsStarted: 'Идет запись, говорите',
    videoWatching: 'Вы можете просмотреть видео с вашим отзывом',
    recordIsFinish: 'Запись завершена!',
    audioRecord: 'Aудио запись',
    orderPaid: 'Платеж по лицевому счету {account} выполнен!',
    feedbackWasLeaved: 'Был оставлен отзыв на роботе',
    sendInfo: 'Передача показаний',
    yourPhoto: 'Ваше фото',
    paperOut: 'Закончилась бумага. Пожалуйста, обратитесь к администратору',
    editPersonalInfo: 'Изменить данные учетной записи',
    personalInfoWasChanged: 'Персональные данные были успешно сохранены',
    wantToLeaveScreen: 'Уверены, что хотите покинуть страницу? Введенные данные не сохранятся',
    needAccount: 'Для использования всех функций Личного кабинета добавьте лицевой счет',
    accountPay: 'Оплата по счету {account}',
    faceNear: 'Лицо слишком близко',
    faceAway: 'Лицо слишком далеко',
    dontMove: 'Не двигайтесь',
    scanReady: 'QR-код считан',
    scanFailed: 'Не удалось считать данные',
    thanksForRegistration: 'Спасибо за регистрацию',
    fieldRequirement: 'Требования к заполнению:',
    personalTerms: 'Пользовательское соглашение об использовании Личного кабинета',
    feedbackTerms: 'Пользовательское соглашение на обработку персональных данных',
    sendInfoNotPossible: 'Ввод показаний невозможен',
    sendEmptyInfo: 'Остались незаполненные показания, Вы уверены, что хотите передать только эти показания?',
    whatIsYourName: 'Как вас зовут?',
    audioFeedbackQuality: 'Вы можете оставить отзыв о качестве обслуживания',
    videoFeedbackQuality: 'Вы можете записать видео отзыв о качестве обслуживания',
    leaveContacts: 'Оставьте свои контактные данные, чтобы<br> наши специалисты могли связаться с вами',
    sendChequeToEmail: 'Отправка чека на email',
    accountManagement: 'Управление лицевыми счетами',
    accountsList: 'Текущие лицевые счета:',
    addAccount: 'Регистрация лицевого счета',
    findAccount: 'Узнать лицевой счет по адресу',
    wrongPassword: 'Неверный пароль',
    operationComplete: 'Операция успешно завершена',
    pay: 'Выполнить платеж на сумму {sum}?',
    account: 'Лицевой счет',
    negativeBalance: 'Остаток:',
    positiveBalance: 'Переплата:',
    payCharges: 'К оплате:',
    emptyMeters: 'Ввод показаний невозможен',
    sendEmailFailed: 'Ошибка отправки',
  },
  texts: {
    thanksForFeedback: 'Ваш отзыв очень важен для нас, вы помогаете делать нашу работу лучше',
    operationNotPossible: 'Устройство временно недоступно',
    scanNotPossible: 'Ошибка оборудования. Невозможно отсканировать квитанцию. Вы можете авторизоваться и произвести оплату через личный кабинет',
    sendPhotoNotPossible: 'По техническим причинам отправить снимок нельзя',
    photoWasSended: 'Фото было отправлено на адрес',
    takeYourPhoto: 'Заберите ваше фото',
    audioInstruction: 'Когда будете готовы оставить отзыв, нажмите на кнопку «Начать» и начните говорить.<br> Я буду внимательно слушать и записывать вашу речь<br> Длина отзыва не более двух минут!',
    videoInstruction: 'Когда будете готовы записать видео отзыв, нажмите на кнопку «Начать», посмотрите на меня и начните говорить. Я буду внимательно смотреть, слушать и записывать вашу речь<br> Длина отзыва не более двух минут!',
    payInstruction: 'Произведите оплату, следуя указаниям на пин&#8209;паде',
    startRecording: 'Нажмите кнопку, чтобы начать запись',
    playRecording: 'Вы можете прослушать аудио отзыв',
    confirmLinkWasSended: 'Вам необходимо подтвердить вашу учетную запись, временный пароль и ссылка для подтверждения учетной записи была отправлена на',
    registrationTerms: 'Нажимая на кнопку «Зарегистрироваться», я подтверждаю, что ознакомился и принял {0}',
    feedbackTerms: 'Нажимая на кнопку «Отправить отзыв», я подтверждаю, что даю своё согласие на {0}',
    termsRegistrationConsent: 'Согласие на обработку персональных данных',
    termsFeedbackConsent: 'обработку персональных данных',
    noRegistration: 'Если Вы еще не зарегистрированы в Личном кабинете, пройдите регистрацию',
    badConnection: 'Не удалось подключиться к сервису, пожалуйста, повторите попытку или обратитесь к администратору',
    pleaseContactAdmin: 'Пожалуйста, обратитесь к администратору',
    editPersonalInfoFailed: 'Не удалось изменить персональные данные пользователя. Вы можете повторить попытку или обратиться к администратору',
    healthWarning: 'Уважаемый клиент! Мы заботимся о здоровье посетителей нашего центра, пожалуйста, пройдите процедуру измерения температуры для получения услуг',
    temperatureMeasureNotPossible: 'Устройство временно недоступно, вы можете продолжить общение с роботом без измерения температуры, для этого нажмите на «На главную»',
    cantMeasureTemperature: 'Не могу измерить температуру',
    measurementInProgress: 'Идет измерение температуры',
    temperatureNormal: 'Ваша температура в норме',
    temperatureBad: 'У вас повышенная температура, Вам следует обратиться к врачу',
    measuringAlreadyDone: 'Повторное измерение в данный момент не требуется',
    scanQr: 'Для оплаты отсканируйте QR-код с квитанции',
    userNotFound: 'Пользователя с таким Логином или паролем нет в базе',
    enterAccountNumber: 'Введите номер лицевого счета, номер указан у вас в квитанции',
    meterInfoWasSended: 'Показания приборов учета переданы',
    sendInfoNotPossible: 'В настоящее время прием показаний недоступен, так как прием показаний осуществляется <b>с {minDay} до {maxDay} числа каждого месяца</b>',
    sendInfoFailed: 'Не удалось передать показания, пожалуйста, повторите попытку или обратитесь к администратору',
    wrongInfo: 'Если вы не согласны с показаниями, пожалуйста, обратитесь к сотруднику отделения',
    emptyOrder: 'Список услуг пуст',
    emptyAccounts: 'У вас пока нет привязанных счетов',
    chequeWasSendedToEmail: 'Чек был отправлен на электронную почту',
    takeYourCheque: 'Заберите ваш чек',
    takeYourChequeAndMore: 'Заберите ваш чек. Желаете ещё оплатить услуги?',
    payFailed: 'Не удалось выполнить обработку платежа, пожалуйста, повторите попытку или обратитесь к администратору',
    accountResolution: 'Постановлением Правительства РФ от 13.07.2019 г. № 897 утверждена типовая форма договора энергоснабжения, согласно которой, в договоре должны быть указаны следующие сведения о собственнике жилого помещения: фамилия, имя, отчество, паспортные данные, ИНН (при наличии), дата и место рождения. В связи с чем, просим, при посещении Энергосбыта, предоставить необходимые сведения вместе с подтверждающими документами, а также подтвердить право на недвижимость',
    accountDescription: 'На этой форме Вы можете управлять несколькими своими лицевыми счетами.<br> Зарегистрировать новый лицевой счет. Для этого достаточно знать номер ЛС и Адрес объекта.',
    bindAccount: 'Для управления Вашими услугами или услугами Ваших близких, привяжите нужные лицевые счета Якутскэнерго',
    findAccount: 'Узнайте номер лицевого счета по адресу',
    addAccountFailed: 'Не удалось привязать лицевой счет к пользователю. Вы можете повторить попытку или обратиться к администратору',
    accountWasAdded: 'Лицевой счет был добавлен в Личный кабинет',
    anotherService: 'Вы можете вернуться в личный кабинет и выбрать другую услугу',
    sum: 'Вы можете изменить сумму платежа',
    balanceAfterPay: 'Баланс по лицевому счёту после оплаты: {balance}',
    creditAfterPay: 'Сумма долга по лицевому счёту после оплаты: {balance}',
    checkEmail: 'Чек будет отправлен на указанную почту.<br> Можно оставить поле пустым, если чек вам не нужен',
    accountNotfound: 'Лицевой счет не найден',
    notfound: 'По вашему запросу «{query}» ничего не найдено',
    noCharges: 'Начислений по выбранному счету не найдено',
    emptyMeters: 'Нет активных приборов',
    touchTerminalCancel: 'Для отмены платежа - нажмите красную кнопку на терминале',
  },
  actions: {
    no: 'Нет',
    yes: 'Да',
    add: 'Добавить',
    home: 'На главную',
    pick: 'Выбрать',
    send: 'Отправить',
    save: 'Сохранить',
    start: 'Начать',
    retry: 'Повторить',
    close: 'Закрыть',
    clear: 'Очистить',
    cancel: 'Отмена',
    takePhoto: 'Сфотографировать',
    backToPhoto: 'Вернуться к фото',
    sendToEmail: 'Отправить на email',
    tapScreen: 'Коснитесь экрана, чтобы начать',
    view: 'Просмотреть',
    abort: 'Прервать',
    finish: 'Завершить',
    listen: 'Прослушать',
    print: 'Распечатать',
    reshoot: 'Переснять',
    enter: 'Войти',
    enterPersonal: 'Войти в личный кабинет',
    exit: 'Выйти',
    rewrite: 'Перезаписать',
    continue: 'Продолжить',
    rescan: 'Пересканировать',
    register: 'Зарегистрироваться',
    understand: 'Понятно',
    finishRecord: 'Завершить запись',
    pay: 'Оплатить',
    yesPay: 'Да, оплатить',
    yesAbort: 'Да, прервать',
    noContinue: 'Нет, продолжить',
    sendFeedback: 'Отправить отзыв',
    noGoBack: 'Нет, вернуться назад',
    payAnother: 'Оплатить остальные услуги',
    selectFrame: 'Выбрать рамку',
    removeFrame: 'Удалить рамку',
    signin: 'Войти<br> в Личный кабинет',
    signup: 'Зарегистрироваться<br> в Личном кабинете',
    payByQr: 'Оплатить услуги по&nbsp;QR&#8209;коду',
    transmit: 'Передать показания приборов учёта',
    toPhoto: 'Сделать фото',
    addFeedback: 'Оставить отзыв',
    sendInfo: 'Передать показания',
    editProfile: 'Изменить данные',
    editAccounts: 'Лицевые счета',
    showBalance: 'Посмотреть баланс и оплатить',
    backToPersonal: 'Вернуться в личный кабинет',
    yesLeave: 'Да, покинуть',
    noStay: 'Нет, остаться',
    addAccount: 'Добавить лицевой счет',
    findAccount: 'Узнать номер Лицевого счета',
    skipAddAccount: 'Продолжить без лицевого счета',
    skipTemperatureMeasure: 'Продолжить без измерения',
    temperatureMeasure: 'Согласен измерить температуру',
    yesSendInfo: 'Да, передать заполненные',
    noAbortSending: 'Нет, заполнить оставшиеся',
    pickYourself: 'Выберите себя на экране',
    addMore: 'Добавить еще',
    viewPrevious: 'Посмотреть предыдущие показания',
    sendMore: 'Еще передать показания',
    openSession: 'Открыть смену',
    closeSession: 'Закрыть смену',
    backToMenu: 'Назад в меню',
    tryAgain: 'Попробовать еще',
  },
};
